// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-message {
  display: flex;
  flex-direction: column;
  margin: 8px 12px;
  width: 100%;
}

.custom-message.mine {
  align-self: flex-end;
}

.custom-message.theirs {
  align-self: flex-start;
}

.msg-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
  font-size: 12px;
  color: #aaa;
}

.msg-sender {
  font-weight: 700;
  color: #c4a7e5;
}

.msg-time {
  font-size: 11px;
  color: #ccc;
}

.msg-bubble {
  background-color: #1e1e1e;
  padding: 10px 14px;
  border-radius: 14px;
  color: white;
  flex: 1 1;
  overflow: hidden;
}

.msg-quote {
  background: rgba(255, 255, 255, 0.06);
  border-left: 3px solid #7c3aed;
  border-radius: 8px;
  padding: 8px 10px;
  margin-bottom: 8px;
  max-width: 100%;
}

.msg-quote-author {
  font-size: 12px;
  color: #c4b5fd; /* light purple */
  font-weight: 600;
  margin-bottom: 4px;
}

.msg-quote-text {
  font-size: 13px;
  color: #e5e7eb;
  word-break: break-word;
  overflow-wrap: break-word;
}

.msg-attachments {
  margin-top: 8px;
  max-width: 100%;
}

.msg-attachments .str-chat__attachment-list,
.msg-attachments .str-chat__message-attachment,
.msg-attachments .str-chat__message-attachment-dynamic-size {
  max-width: 100%;
  width: 100%;
  box-sizing: border-box;
}

.msg-attachments img,
.msg-attachments video,
.msg-attachments .react-player,
.msg-attachments .str-chat__player-wrapper {
  max-width: 100% !important;
  width: 100% !important;
  height: auto;
}

.msg-attachments .str-chat__attachment {
  background: transparent;
  color: #e5e7eb;
}

.msg-attachments .str-chat__message-attachment--file .str-chat__attachment {
  background: #2b2b2b;
  border-radius: 10px;
}

.msg-attachments .str-chat__message-attachment-file--item-name,
.msg-attachments .str-chat__message-attachment-file--item,
.msg-attachments .str-chat__message-attachment-file--item-text {
  background: white;
}

.msg-attachments .str-chat__file-icon {
  color: #e5e7eb;
  fill: currentColor;
  stroke: currentColor;
}

.msg-attachments .str-chat__message-attachment-file--item-first-row button,
.msg-attachments .str-chat__file-attachment__download-button,
.msg-attachments .str-chat__file-attachment__download-button svg {
  color: #e5e7eb;
  fill: currentColor;
  stroke: currentColor;
}

.msg-attachments a {
  color: #dbeafe;
}

.msg-row {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  width: 100%;
  flex-direction: row-reverse;
}

.custom-message.mine .msg-row {
  flex-direction: row-reverse;
}

.msg-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
  font-size: 12px;
  color: #aaa;
}

.custom-message.mine .msg-bubble {
  background-color: #2f2047;
  color: white;
}

.custom-message.theirs .msg-bubble {
  background-color: #242626;
  color: #fff;
}

.msg-actions-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
  padding-inline-start: 44px;
  padding-inline-end: 0;
}

.custom-message.mine .msg-actions-row {
  justify-content: flex-end;
  padding-inline-start: 0;
  padding-inline-end: 44px;
}

.msg-actions-row > * {
  flex: 0 0 auto;
}

.msg-actions-row .str-chat__message-options {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #fff;
}

.msg-actions-row .str-chat__message-simple__actions__action,
.msg-actions-row .str-chat__message-reply-in-thread-button,
.msg-actions-row .str-chat__message-reactions-button {
  margin: 0;
  color: #fff;
}

.msg-actions-row .str-chat__message-reactions-container {
  display: inline-flex;
  align-items: center;
  margin: 0;
}

.msg-actions-row .str-chat__message-reactions {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  padding: 0;
}

.msg-actions-row .str-chat__message-action-icon,
.msg-actions-row .str-chat__message-options svg {
  color: #fff;
  fill: currentColor;
  stroke: currentColor;
}

/* Deleted and edited states */
.msg-deleted {
  font-style: italic;
  color: #9ca3af;
}
.msg-edited {
  margin-left: 6px;
  font-size: 11px;
  color: #9ca3af;
}

.custom-avatar .str-chat__avatar {
  background-color: var(--avatar-color) !important;
}

.custom-avatar .str-chat__avatar-fallback {
  background-color: var(--avatar-color) !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/sidebar/CustomMessage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc,EAAE,iBAAiB;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;;;EAGE,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;;;;EAIE,0BAA0B;EAC1B,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;;EAGE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;;;EAGE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD","sourcesContent":[".custom-message {\n  display: flex;\n  flex-direction: column;\n  margin: 8px 12px;\n  width: 100%;\n}\n\n.custom-message.mine {\n  align-self: flex-end;\n}\n\n.custom-message.theirs {\n  align-self: flex-start;\n}\n\n.msg-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 4px;\n  font-size: 12px;\n  color: #aaa;\n}\n\n.msg-sender {\n  font-weight: 700;\n  color: #c4a7e5;\n}\n\n.msg-time {\n  font-size: 11px;\n  color: #ccc;\n}\n\n.msg-bubble {\n  background-color: #1e1e1e;\n  padding: 10px 14px;\n  border-radius: 14px;\n  color: white;\n  flex: 1;\n  overflow: hidden;\n}\n\n.msg-quote {\n  background: rgba(255, 255, 255, 0.06);\n  border-left: 3px solid #7c3aed;\n  border-radius: 8px;\n  padding: 8px 10px;\n  margin-bottom: 8px;\n  max-width: 100%;\n}\n\n.msg-quote-author {\n  font-size: 12px;\n  color: #c4b5fd; /* light purple */\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.msg-quote-text {\n  font-size: 13px;\n  color: #e5e7eb;\n  word-break: break-word;\n  overflow-wrap: break-word;\n}\n\n.msg-attachments {\n  margin-top: 8px;\n  max-width: 100%;\n}\n\n.msg-attachments .str-chat__attachment-list,\n.msg-attachments .str-chat__message-attachment,\n.msg-attachments .str-chat__message-attachment-dynamic-size {\n  max-width: 100%;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.msg-attachments img,\n.msg-attachments video,\n.msg-attachments .react-player,\n.msg-attachments .str-chat__player-wrapper {\n  max-width: 100% !important;\n  width: 100% !important;\n  height: auto;\n}\n\n.msg-attachments .str-chat__attachment {\n  background: transparent;\n  color: #e5e7eb;\n}\n\n.msg-attachments .str-chat__message-attachment--file .str-chat__attachment {\n  background: #2b2b2b;\n  border-radius: 10px;\n}\n\n.msg-attachments .str-chat__message-attachment-file--item-name,\n.msg-attachments .str-chat__message-attachment-file--item,\n.msg-attachments .str-chat__message-attachment-file--item-text {\n  background: white;\n}\n\n.msg-attachments .str-chat__file-icon {\n  color: #e5e7eb;\n  fill: currentColor;\n  stroke: currentColor;\n}\n\n.msg-attachments .str-chat__message-attachment-file--item-first-row button,\n.msg-attachments .str-chat__file-attachment__download-button,\n.msg-attachments .str-chat__file-attachment__download-button svg {\n  color: #e5e7eb;\n  fill: currentColor;\n  stroke: currentColor;\n}\n\n.msg-attachments a {\n  color: #dbeafe;\n}\n\n.msg-row {\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n  width: 100%;\n  flex-direction: row-reverse;\n}\n\n.custom-message.mine .msg-row {\n  flex-direction: row-reverse;\n}\n\n.msg-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 6px;\n  font-size: 12px;\n  color: #aaa;\n}\n\n.custom-message.mine .msg-bubble {\n  background-color: #2f2047;\n  color: white;\n}\n\n.custom-message.theirs .msg-bubble {\n  background-color: #242626;\n  color: #fff;\n}\n\n.msg-actions-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 4px;\n  padding-inline-start: 44px;\n  padding-inline-end: 0;\n}\n\n.custom-message.mine .msg-actions-row {\n  justify-content: flex-end;\n  padding-inline-start: 0;\n  padding-inline-end: 44px;\n}\n\n.msg-actions-row > * {\n  flex: 0 0 auto;\n}\n\n.msg-actions-row .str-chat__message-options {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: #fff;\n}\n\n.msg-actions-row .str-chat__message-simple__actions__action,\n.msg-actions-row .str-chat__message-reply-in-thread-button,\n.msg-actions-row .str-chat__message-reactions-button {\n  margin: 0;\n  color: #fff;\n}\n\n.msg-actions-row .str-chat__message-reactions-container {\n  display: inline-flex;\n  align-items: center;\n  margin: 0;\n}\n\n.msg-actions-row .str-chat__message-reactions {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin: 0;\n  padding: 0;\n}\n\n.msg-actions-row .str-chat__message-action-icon,\n.msg-actions-row .str-chat__message-options svg {\n  color: #fff;\n  fill: currentColor;\n  stroke: currentColor;\n}\n\n/* Deleted and edited states */\n.msg-deleted {\n  font-style: italic;\n  color: #9ca3af;\n}\n.msg-edited {\n  margin-left: 6px;\n  font-size: 11px;\n  color: #9ca3af;\n}\n\n.custom-avatar .str-chat__avatar {\n  background-color: var(--avatar-color) !important;\n}\n\n.custom-avatar .str-chat__avatar-fallback {\n  background-color: var(--avatar-color) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
